module.exports = __webpack_public_path__ + "img/company.1ac793d4.jpg";